export enum DocumentSectionStatus {
    Requested = 0,
    Submitted = 1,
    Accepted = 2,
    Rejected = 3,
    Outstanding = 4
}
